import styled from "styled-components";
import Highlight from "react-highlight";

export const Container = styled.div`
  padding: 7vh;
  overflow-x: hidden;
  @media (max-width: 600px) {
    padding: 4vh;
  }
`;

export const LongImage = styled.div`
  overflow-x: scroll;
`;

export const Logo = styled.p`
  font-family: "Gugi", cursive;
  font-size: 26px;
  margin: 0;
  text-align: center;
  color: #ff0080;
`;

export const BasicText = styled.p`
  font-family: "Titillium Web", sans-serif;
  font-weight: 300;
  color: "#292836";
  font-size: 16px;
  margin: 0;
`;

export const Heading = styled.p`
  font-family: "Roboto", cursive;
  font-weight: 400;
  color: #000;
  margin-top: 7px;
  margin-bottom: 12px;
  font-size: 30px;
`;

export const Heading3 = styled.p`
  font-family: "Roboto", cursive;
  font-weight: 400;
  color: #000;
  margin-top: 7px;
  margin-bottom: 5px;
  font-size: 24px;
`;

export const CodeView = styled(Highlight)`
  align-self: stretch;
  background-color: #f8f9fa;
`;

export const Highlighter = styled.div`
  background-color: #f8f9fa;
  padding: 2px 4px 2px 4px;
  border-radius: 3px;
  display: inline;
  margin-left: 3px;
  margin-right: 2px;
`;
export const CodeOuter = styled.div`
  align-self: stretch;
  background-color: #f8f9fa;
  padding: 2px;
  padding-right: 10px;
  padding-left: 10px;
  margin-right: 10vw;
  margin-top: 10px;
  border-radius: 5px;

  @media (max-width: 600px) {
    margin-right: 0;
  }
`;
